import {
  Button,
  Sheet, SheetClose,
  SheetContent, SheetContentWrapper,
  SheetHeader,
  SheetOverlay,
  SheetPortal, SheetTitle, tok,
} from '@sunwebgroup/ui-components';
import { useService } from '@/scopes/checkout/domain/hooks';
import { ServiceType } from '@/scopes/checkout/domain/types';
import * as React from 'react';
import { styled } from 'styled-components';
import { useIntl } from '@/intl';
import { FilterableCarsAvailable } from '@/scopes/checkout/components/services/CarRentalFilteringService/FilterableCars/FilterableCarsAvailable';
import { createCarEvent } from '@/scopes/checkout/domain/analytics';
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks';
import {
  showingFilterableCars,
  useCarRentalServiceStore,
} from '@/scopes/checkout/components/services/CarRentalFilteringService/store';

export function RentalCarListerView(){
  const {service} = useService(ServiceType.CarRentalFiltering);
  const intl = useIntl();
  const {sendEvent} = useAnalytics();
  const { setShowFilterableCars } = useCarRentalServiceStore();
  const isShowingFilterableCars = useCarRentalServiceStore(showingFilterableCars);

  const handleOpenChange = (isOpen: boolean) => {
    setShowFilterableCars(isOpen);
    if (isOpen) {
      sendEvent(
        createCarEvent({
          result: 'Show all available cars',
          description: 'Filterable cars sheet opened',
          element: 'bottom sheet',
          validated: true
        })
      )
    } else {
      sendEvent(
        createCarEvent({
          result: 'Hide all available cars',
          description: 'Filterable cars sheet closed',
          element: 'bottom sheet',
          validated: true
        })
      )
    }
  };

  if (!service) return null;
  return (
    <>
      <Button $hierarchy="secondary" $withoutColor  onClick={() => handleOpenChange(true)}>{intl.formatMessage({id: 'checkout_steps_ancillaries_car_rental_filtering_show_all_action'})}</Button>
      <Sheet modal open={isShowingFilterableCars}>
        <SheetPortal>
          <SheetOverlay onClick={() => handleOpenChange(false)}/>
          <StyledSheetContent $side="bottom">
            <SheetHeader>
              <SheetTitle>
                {intl.formatMessage({id: 'checkout_steps_ancillaries_car_rental_filtering_all_cars_title'})}
              </SheetTitle>
              <SheetClose onClick={() => handleOpenChange(false)}>{intl.formatMessage({id: 'checkout_steps_ancillaries_car_rental_filtering_all_cars_close_text'})}</SheetClose>
            </SheetHeader>
            <FilterableCarsAvailable />
          </StyledSheetContent>
        </SheetPortal>
      </Sheet>
    </>
  )
}

const StyledSheetContent = styled(SheetContent)`
  background-color: ${tok('semantics_backgrounds_tinted_background_color')};
  overflow: hidden;
  ${SheetContentWrapper}{
    padding: 0;
    max-height: calc(100% - 48px);
  }
`
